var a="\ngl_FragColor.rgb *= dAlpha;\ngl_FragColor.a = dAlpha;\n";export{a as default};
